import { MenuAction } from '@shared/interfaces/header/menu-action';
import { FolderSync, PencilLine, PlusSquare, Trash } from 'lucide-angular';

export const meteringpointListActionMenu: MenuAction[] = [
  {
    id: 'create',
    title: 'meteringPoint.list.create.title',
    breaker: false,
    icon: PlusSquare
  },
  {
    id: 'edit',
    title: 'meteringPoint.list.edit.title',
    icon: PencilLine,
    disabled: true
  },
  {
    id: 'master',
    title: 'meteringPoint.list.coredata.title',
    icon: FolderSync,
    breaker: true,
  },
  {
    id: 'close',
    title: 'meteringPoint.list.close.title',
    icon: Trash,
    iconColor: 'text-red-500',
    disabled: true,
  },
];
